module.exports = __webpack_public_path__ + "static/media/logo-piario.7c9feff6.svg";